<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="login d-flex flex-column flex-lg-row flex-column-fluid bg-white"
      id="kt_login"
    >
      <!--begin::Aside-->
      <div
        class="
          login-aside
          d-flex
          flex-column
          justify-content-center
          flex-row-auto
        "
        style="background-color: transparent"
      >
        <div class="d-flex flex-column-auto flex-column py-30">
          <a href="/" class="text-center mb-10">
            <img
              src="media/logo/logoTMG.png"
              class="max-h-200px"
              alt="logo-tell-me-genius"
            />
          </a>
          <h3
            class="font-weight-bolder text-center font-size-h4 font-size-h1-lg"
            style="color: #3a2140"
          >
            {{ $t("login.text") }}
          </h3>
        </div>
      </div>
      <!--begin::Aside-->
      <!--begin::Content-->
      <div
        class="
          login-content
          flex-row-fluid
          d-flex
          flex-column
          justify-content-center
          position-relative
          overflow-hidden
          p-7
          mx-auto
        "
      >
        <div class="d-flex flex-column-fluid flex-center">
          <SignInStep1Form v-if="state == 'signin1'" @showForm="showForm" />
          <SignInStep2Form v-if="state == 'signin2'" @showForm="showForm" />
          <SignUpForm v-if="state == 'signup'" @showForm="showForm" />
          <!-- Le v-if ci-dessous supprime l'animation lors de l'affichage du formulaire mais permet d'éviter un bug lorsque l'internaute arrive sur cette page suite à une redirection (par exemple lorsqu'il tente d'acceder au tableau de bord sans être connecté) -->
          <ForgotForm
            v-if="state === 'forgot'"
            @showForm="showForm"
            :title="$t('login.forgot')"
            :sub-title="$t('login.forgotText')"
          />
          <ResetForm v-if="state == 'reset'" @showForm="showForm" />
        </div>
      </div>
      <!--end::Content-->
    </div>
    <!--begin::Content footer-->
    <div class="d-flex justify-content-center align-items-center py-7 py-lg-4">
      <div class="text-dark d-flex flex-wrap justify-content-center">
        <div class="text-muted font-weight-bold pr-1" id="year">
          ©{{ new Date().getFullYear() }}
        </div>
        <div class="pr-2">Tell Me Genius</div>
        <div class="px-4"><Cgu /></div>
        <div class="pl-2">
          <a
            href="https://www.insaniam.fr/"
            target="_blank"
            class="text-dark-75 text-hover-primary"
            >{{ $t("common.footer") }}</a
          >
        </div>
      </div>
    </div>
    <!--end::Content footer-->
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login.scss";
</style>

<script>
//import KTUtil from "@/assets/js/components/util";
import ForgotForm from "@/components/auth/forgotForm";
import SignInStep1Form from "@/components/auth/signInStep1Form";
import SignInStep2Form from "@/components/auth/signInStep2Form";
import SignUpForm from "@/components/auth/signUpForm";
import ResetForm from "@/components/auth/resetForm";
import Cgu from "@/components/common/cgu";
import Swal from "sweetalert2";

export default {
  name: "login",
  components: {
    ForgotForm,
    SignInStep1Form,
    SignInStep2Form,
    SignUpForm,
    ResetForm,
    Cgu,
  },
  data() {
    return {
      state: "signin1",
    };
  },
  mounted() {
    switch (this.$route.name) {
      case "resetPassword":
        this.state = "reset";
        break;
    }
    var isIE =
      navigator.userAgent.toLowerCase().indexOf("gecko") == -1 ? true : false;
    if (isIE) {
      Swal.fire({
        title: this.$i18n.t("common.browserAlert"),
        text: this.$i18n.t("common.browser"),
        icon: "error",
        confirmButtonClass: "btn btn-secondary",
      });
    }
  },
  methods: {
    showForm(form) {
      this.state = form;
    },
  },
  metaInfo: {
    // Les enfants peuvent remplacer le titre.
    title: 'Connexion',
    meta: [
      {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1'},
      {name: 'description', content: 'Page de connexion de l\'application TellMeGenius.'}
    ]
  }
};
</script>
